<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
import moment from "moment";
import { ma } from "moving-averages";
import utilChart from "../utils/chart";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        data: ["Localizados", "Não localizados", "Total"],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "value",
            name: "Clientes",
            splitNumber: 10,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: [],
            axisLabel: {
              lineHeight: 13,
              fontSize: 9,
              rotate: 40,
              showMinLabel: true,
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
            },
          },
        ],
        series: [
          {
            name: "Novos",
            type: "bar",
            barWidth: "20%",
            color: "#8bc34a",
            barGap: 0,
            label: {
              show: false,
            },
            stack: "novos",
            data: [],
          },
          {
            name: "Localizados",
            type: "bar",
            barWidth: "60%",
            color: "#e91e63",
            label: {
              show: false,
            },
            stack: "total",

            data: [],
          },
          {
            name: "Não localizados",
            type: "bar",
            color: "#3f51b5",
            stack: "total",
            label: {
              show: false,
            },
            data: [],
          },
          {
            name: "Total",
            type: "bar",
            barWidth: 0,
            stack: "all",
            label: {
              show: false,
            },
            data: [],
            color: "#263238",
          },
          {
            name: "M10 total",
            type: "line",
            yAxisIndex: 0,
            label: {
              show: false,
            },
            showSymbol: false,
            color: "#263238",
            data: [],
          },
          {
            name: "M10 localizados",
            type: "line",
            yAxisIndex: 0,
            label: {
              show: false,
            },
            showSymbol: false,
            color: "#f48fb1",
            data: [],
          },
          {
            name: "M10 não localizados",
            type: "line",
            yAxisIndex: 0,
            label: {
              show: false,
            },
            showSymbol: false,
            color: "#7986cb",
            data: [],
          },
          {
            name: "M10 novos",
            type: "line",
            yAxisIndex: 0,
            label: {
              show: false,
            },
            showSymbol: false,
            color: "#aed581",
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (!this.data.length) return this.defaultOptions;
      return this.renderChart();
    },
  },
  methods: {
    renderChart() {
      let options = { ...this.defaultOptions };
      let customersArray = [];
      let locatedArray = [];
      let notLocatedArray = [];
      let incomingArray = [];
      options.series[0].data = [];
      options.series[1].data = [];
      options.series[2].data = [];
      options.series[3].data = [];
      options.series[4].data = [];
      options.xAxis[0].data = [];
      this.data.forEach((node) => {
        options.series[0].data.push(node.incoming);
        options.series[1].data.push(node.located);
        options.series[2].data.push(node.not_located);
        options.series[3].data.push(node.customers);
        options.xAxis[0].data.push(moment(node.created_at).format("DD/MM"));
      });
      // Médias
      this.data.forEach((node) => {
        customersArray.push(node.customers);
        locatedArray.push(node.located);
        notLocatedArray.push(node.not_located);
        incomingArray.push(node.incoming);
      });

      options.series[4].data = ma(customersArray, 10);
      options.series[5].data = ma(locatedArray, 10);
      options.series[6].data = ma(notLocatedArray, 10);
      options.series[7].data = ma(incomingArray, 10);

      options.series[4].data = options.series[4].data.slice(
        Math.max(options.series[4].data.length - utilChart.periods, 0)
      );
      options.series[5].data = options.series[5].data.slice(
        Math.max(options.series[5].data.length - utilChart.periods, 0)
      );
      options.series[6].data = options.series[6].data.slice(
        Math.max(options.series[6].data.length - utilChart.periods, 0)
      );
      options.series[7].data = options.series[7].data.slice(
        Math.max(options.series[7].data.length - utilChart.periods, 0)
      );
      return options;
    },
  },
};
</script>

<style></style>
